<template>
  <svg :class="cssClass" viewBox="0 0 24 24">
    <g fill-rule="evenodd">
      <path
        d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
        fill-rule="nonzero"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    cssClass: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
svg {
  width: 100%;
  height: auto;
}
</style>
